import {
  isMultiMarketEnabled,
  isTrackerEnabled
} from '../../constants/featureFlags'
import { ProjectType } from '../../data/gql-gen/dashboard/graphql'
import { ProjectTypesItem } from '../../modules/Project/Project.model'
import { hasFeatureAccess } from '../../utils/authUtils'

const coreProjectType: ProjectTypesItem = {
  title: 'FD Core - Quant Survey',
  description:
    'Get robust quant survey data at exceptional quality and speed. Available across 120+ markets.',
  type: ProjectType.AdHoc,
  defaultCompletes: 2000
}

const chatProjectType: ProjectTypesItem = {
  title: 'FD Chat - Qual Interviews',
  description: 'Get in-depth insights at scale using AI-moderated interviews.',
  type: ProjectType.FdChat,
  defaultCompletes: 100
}

const multiMarketProjectType: ProjectTypesItem = {
  title: 'FD Core - Multi-Market Project',
  description:
    'Run multi-market projects and create an automatic multi-market dashboard.',
  type: ProjectType.MultiMarketV2,
  defaultCompletes: 2000
}

// Declared at creation: there is no way to turn an existing project into one.
const trackerProjectType: ProjectTypesItem = {
  title: 'FD Core - Multi-Wave Tracker',
  description:
    'Track the same questions over repeated waves and compare results across them.',
  type: ProjectType.Tracker,
  defaultCompletes: 2000
}

export const getAvailableProjectTypes = () => {
  const projectTypes: ProjectTypesItem[] = [coreProjectType]

  if (hasFeatureAccess('FdChat')) {
    projectTypes.push(chatProjectType)
  }

  if (isMultiMarketEnabled()) {
    projectTypes.push(multiMarketProjectType)
  }

  if (isTrackerEnabled()) {
    projectTypes.push(trackerProjectType)
  }

  return projectTypes
}

const allProjectTypes: ProjectTypesItem[] = [
  coreProjectType,
  chatProjectType,
  multiMarketProjectType,
  trackerProjectType
]

export const getDefaultCompletes = (projectType: ProjectType) => {
  return (
    allProjectTypes.find((project) => project.type === projectType)
      ?.defaultCompletes ?? 2000
  )
}
